import axios from 'axios';
import { API_BASE_URL } from '@config/apiConfig';
const postProcessCoupon = async (codeName, isCouponRedemptionInPayments) => {
    const url = isCouponRedemptionInPayments ? `${API_BASE_URL}/payments/process-coupon` : '/process_coupon';
    return axios.post(url, {
        code: codeName,
    });
};
export default postProcessCoupon;
